<template>
    <div class = "login_container">
        <input class="login_round_box" type="text" v-model="state.form.user_id" placeholder="아이디"/>
        <input class="login_round_box" type="password" v-model="state.form.password" placeholder="비밀번호" />
        <button id="login_btn" @click="login_try()">로그인</button>
    </div>
</template>

<script>
import store from '../../js/store.js'
import { reactive } from '@vue/reactivity'
import API from '../../js/API.js'

import Swal from "sweetalert2";

export default {
    name: "popup_login",
    setup() {

    },
    data() {
        return {
            state : reactive({
                form: {
                    user_id: '',
                    password: '',
                }
            }),
            
            account_info: {
                id: null,
                nickname: null,
                grade: '',
                cash: 0,
                credit: 0,
                point: 0,
                bank_code: -1,
                bank_name: '',
                bank_account: -1,
                phone: '',
                token: null
            }
        }
    },
    methods:{
        
        login_try: function(){
            console.log(this.state.form);
            API.AxiosPost('users/logIn', this.state.form, false,
            (res) => {
                    console.log(res);
                    if (res.status == 200) {
                        switch(res.data.code)
                        {
                            case '200':{
                                const accountData = res.data.data;
                                accountData.id = this.state.form.user_id;  // ← 로그인 입력값 저장
                                store.commit('setUser', accountData)
                                store.commit('setGameSettings', res.data.data.game_settings);
                                this.login_success();
                                break;
                            }
                            case '323':
                                Swal.fire({
                                    icon: 'warning',
                                    text: '가입 승인 대기 중 입니다. 잠시 후 다시 시도해 주세요.',
                                })
                                break;
                            case '301':
                                Swal.fire({
                                    icon: 'error',
                                    text: '해당 계정은 이미 접속 중이므로 중복 접속할 수 없습니다.',
                                })
                                break;
                            case '997':
                                Swal.fire({
                                    icon: 'error',
                                    text: res.data.data,
                                })
                                break;
                            case '996':
                                Swal.fire({
                                    icon: 'error',
                                    text: res.data.data,
                                })
                                break;
                            case '306':
                                Swal.fire({
                                    icon: 'error',
                                    text: '접속 제한회원입니다. 운영팀에 문의하십시요.',
                                })
                                break;
                            case '307':
                            case '318':
                                Swal.fire({
                                    icon: 'error',
                                    text: '아이디나 비밀번호를 확인하십시요.',
                                })
                                break;
                            default:
                                console.log("return code : " + res.data.code);
                        }
                    }
                    else {
                        console.log("return status : " + res.status);
                    }
                }
            )
        },

        login_success: function(){
            this.$root.sendMessage('join room')
            this.$root.ClosePopup();
            API.showToast('success', '로그인 성공');
        }
    }
}
</script>

<style>
.login_container {
  width: 500px;
  max-height: calc(100vh - 200px);
  
  margin: 0px auto;
  padding: 20px 30px;
}
.login_round_box{
    height: 40px;
    width: 250px;
    border: 1px;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    margin-bottom: 10px;
    padding-left: 20px;
    padding-top: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
#login_btn{
    height: 40px;
    width: 250px;
    border: 1px;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    margin-bottom: 10px;
    padding-left: 20px;
    padding-top: 5px;
    background-color: #2d88ff;
    color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
</style>../../js/API.js